exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form .col-md-3{width:40%}.table th.column-sort{cursor:pointer}.table td{padding:5px 10px}.complaint-table{font-size:13px}.complaint-table th{background:#d8e2f2;color:#555}.complaint-table td,.complaint-table th{text-align:center;vertical-align:middle!important}.complaint-table-input{background:transparent;border:0;box-shadow:none;width:100%}.complaint-table-input:focus{background:#fff;outline:1px solid #66afe9}.complaint-grand-total{font-weight:700}.complaint-table input[type=number]::-webkit-inner-spin-button,.complaint-table input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.complaint-table input[type=number]{-moz-appearance:textfield;appearance:textfield}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d5ff18c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/manual-forms/complain-table.vue
// module id = 698
// module chunks = 27